import {createStore} from "vuex";

// Modules
import videoState from "@/store/video-state";

export default createStore({
    modules: {
        video: videoState
    }
});